import { instrumentRunQueryKeys } from '@/config/queryKeys';
import { apiClient } from '@/lib/api-client';
import type { InstrumentRunPublic } from '@/types';

/**
 * Fetch a single instrument run by ID
 *
 * @param orgId - The organization ID
 * @param runId - The instrument run ID
 * @returns Promise resolving to the instrument run data
 *
 * @throws {ApiError} If the request fails or the run is not found
 *
 * @example
 * ```typescript
 * const run = await fetchInstrumentRun('org-123', 'run-456');
 * console.log(run.name, run.status);
 * ```
 */
export async function fetchInstrumentRun(orgId: string, runId: string): Promise<InstrumentRunPublic> {
  const result = await apiClient.get<InstrumentRunPublic>(instrumentRunQueryKeys.endpoints.detail(orgId, runId), {
    expectJson: true,
  });

  if (result === null) {
    throw new Error(`Instrument run ${runId} not found`);
  }

  return result;
}
